// src
import { logout } from "services/ms365";
import { clearStorage } from "utils/storage";

export default () => {
  clearStorage();
  logout();
  return null;
};
